<template>
    <footer id="footer" class="footer mt-auto">
        <div class="inner mt-3 text-center">
            <p>Using <a target=_blank href="https://vuejs.org">Vue Js,</a> By <a href="https://twitter.com/rijalpermana">Rijal Permana</a>.</p>
        </div>
    </footer>
</template>

<script>
    import '../assets/css/Footer.css'
    export default {
        name: 'footerSection'
    }
</script>
